import * as React from 'react';
import { ConfigurationMobile } from './components/ConfigurationMobile';
import { IConfigurationFormatted } from '../../types/project';
import { Section } from '../Section';

interface IConfigurationsMobileProps {
  configurations: IConfigurationFormatted[];
  onSelectConfiguration(configuration: IConfigurationFormatted): void;
}

export const ConfigurationsMobile: React.FC<IConfigurationsMobileProps> = ({
  configurations,
  onSelectConfiguration,
}) => {
  return (
    <Section title="Комплектация">
      {configurations.map((configuration, index) => (
        <ConfigurationMobile key={index} {...configuration} onClick={() => onSelectConfiguration(configuration)} />
      ))}
    </Section>
  );
};
